import React from 'react';
import { renderCvHighlighter } from '../utils/cvHighlighter';

const kurzUrl = url => (url || '').replace(/^https?:\/\/(www\.)?/, '');

export function Kopf({ profil, nutzer, fotoUrl, onFotoClick, markierungen = [], onProfilClick }) {
  const vollName = `${nutzer?.vorname || ''} ${nutzer?.nachname || ''}`.trim() || nutzer?.name || '';
  const adresse = nutzer?.anschrift || [nutzer?.strasse, nutzer?.hausnummer, nutzer?.plz, nutzer?.ort].filter(Boolean).join(' ');
  const kontakt = [adresse, nutzer?.telefon, nutzer?.email].filter(Boolean).join(' | ');
  const links = [
    nutzer?.linkedin  ? `LinkedIn: ${kurzUrl(nutzer.linkedin)}`  : null,
    nutzer?.portfolio ? `Website: ${kurzUrl(nutzer.portfolio)}`  : null,
    nutzer?.github    ? `GitHub: ${kurzUrl(nutzer.github)}`      : null,
  ].filter(Boolean).join(' | ');
  return (
    <div className="cv-m-kopf">
      <div className="cv-kopf-oben">
        <div className="cv-kopf-text">
          <h1 className="cv-m-name">{vollName.toUpperCase()}</h1>
          <p className="cv-m-kontakt">{kontakt}</p>
          {links && <p className="cv-m-kontakt">{links}</p>}
        </div>
        {fotoUrl && (
          <img
            src={fotoUrl}
            className="cv-kopf-foto"
            alt=""
            onClick={onFotoClick || undefined}
            style={onFotoClick ? { cursor: 'pointer' } : undefined}
          />
        )}
        {!fotoUrl && onFotoClick && (
          <button className="cv-kopf-foto-placeholder" onClick={onFotoClick} title="Foto hinzufügen">
            <span>+</span>
            <span className="cv-kopf-foto-label">Foto</span>
          </button>
        )}
      </div>
      <hr className="cv-m-linie" />
      <p
        className={`cv-m-profil${onProfilClick ? ' cv-profil-editierbar' : ''}`}
        onClick={onProfilClick || undefined}
      >{renderCvHighlighter(profil, markierungen)}</p>
      <hr className="cv-m-linie" />
    </div>
  );
}

export function Sektion({ s, sektionIdx, zeigeTitel = true, vonEintrag = 0, bisEintrag, markierungen = [], skeleton = false }) {
  const eintraege = s.typ === 'eintraege' ? s.eintraege.slice(vonEintrag, bisEintrag) : [];

  return (
    <div className="cv-m-sektion">
      {zeigeTitel && (
        <h2 className="cv-m-sektion-titel"
            {...(sektionIdx !== undefined ? { 'data-sektion-titel': sektionIdx } : {})}>
          {s.name.toUpperCase()}
        </h2>
      )}
      {s.typ === 'kenntnisse' && (
        <div className="cv-m-kenntnisse-grid">
          {(s.kenntnisse || [])
            .filter(k => !/sprach/i.test(k.kategorie || ''))
            .map((k, i) => (
              <div key={i} className="cv-m-kenntnis">
                <div className="cv-m-kenntnis-titel">{k.titel}</div>
                {(k.beschreibung || '').trim() && (
                  <div className="cv-m-kenntnis-beschr">{renderCvHighlighter(k.beschreibung, markierungen)}</div>
                )}
              </div>
            ))}
        </div>
      )}
      {s.typ === 'eintraege' && (
        <div className="cv-m-eintraege-liste">
          {eintraege.map((e, localIdx) => {
            const globalIdx = vonEintrag + localIdx;
            // Firma und Ort stecken als "Firma · Ort" in einem Feld — für die Skelett-Kapseln aufteilen,
            // damit der Ort auch beim Bearbeiten einen eigenen Platzhalter bekommt.
            const org = e.firma || e.arbeitgeber || '';
            const sepIdx = org.indexOf(' · ');
            const firma = sepIdx >= 0 ? org.slice(0, sepIdx) : org;
            const ort = sepIdx >= 0 ? org.slice(sepIdx + 3) : '';
            return (
              <div key={globalIdx} className="cv-m-eintrag"
                   {...(sektionIdx !== undefined ? { 'data-eintrag': `${sektionIdx}-${globalIdx}` } : {})}>
                <div className="cv-m-eintrag-kopf">
                  <span className={`cv-m-firma${skeleton ? ' cv-skel-titel-row' : ''}`}>
                    {skeleton ? (
                      <>
                        {firma ? renderCvHighlighter(firma, markierungen)
                               : <span className="cv-skel cv-skel-titel-teil" />}
                        <span className="cv-skel-sep">·</span>
                        {ort ? renderCvHighlighter(ort, markierungen)
                             : <span className="cv-skel cv-skel-titel-teil" />}
                      </>
                    ) : (() => {
                      const firmaText = e.firma || e.arbeitgeber;
                      if (!firmaText) return null;
                      const [name, ...rest] = firmaText.split('|').map(s => s.trim());
                      return rest.length > 0
                        ? <>{name.toUpperCase()},&nbsp;<span style={{ fontWeight: 400 }}>{rest.join(', ').toUpperCase()}</span></>
                        : name.toUpperCase();
                    })()}
                  </span>
                  {(e.datum || skeleton) && (
                    <span className="cv-m-datum">
                      {e.datum || <span className="cv-skel cv-skel-datum" />}
                    </span>
                  )}
                </div>
                {((e.rolle || e.jobtitel) || skeleton) && (
                  <div className="cv-m-rolle">
                    {(e.rolle || e.jobtitel) || <span className="cv-skel cv-skel-titel-teil" />}
                  </div>
                )}
                {skeleton ? (
                  (e.bullets?.length > 0) ? (
                    <ul className="cv-m-bullets">
                      {e.bullets.map((b, j) => (
                        <li key={j}>
                          {(b || '').trim()
                            ? renderCvHighlighter(b, markierungen)
                            : <span className="cv-skel cv-skel-bullet" />}
                        </li>
                      ))}
                    </ul>
                  ) : (
                    <ul className="cv-m-bullets">
                      <li><span className="cv-skel cv-skel-bullet" /></li>
                      <li><span className="cv-skel cv-skel-bullet cv-skel-bullet-short" /></li>
                    </ul>
                  )
                ) : (
                  (e.bullets || []).some(b => (b || '').trim()) && (
                    <ul className="cv-m-bullets">
                      {e.bullets.filter(b => (b || '').trim()).map((b, j) => (
                        <li key={j}>{renderCvHighlighter(b, markierungen)}</li>
                      ))}
                    </ul>
                  )
                )}
              </div>
            );
          })}
        </div>
      )}
      {s.typ === 'bullets' && (
        <ul className="cv-m-bullets">
          {(s.bullets || []).map((b, i) => <li key={i}>{renderCvHighlighter(b, markierungen)}</li>)}
        </ul>
      )}
    </div>
  );
}

export function Footer({ nutzer }) {
  const vollName = `${nutzer?.vorname || ''} ${nutzer?.nachname || ''}`.trim() || nutzer?.name || '';
  const adresse = [nutzer?.strasse, nutzer?.hausnummer, nutzer?.plz, nutzer?.ort].filter(Boolean).join(' ');
  return (
    <div className="cv-m-footer">
      {[vollName, adresse, nutzer?.telefon, nutzer?.email].filter(Boolean).join(' | ')}
    </div>
  );
}
